<template>
  <span class="custom-icon" :style="cStyle" @click.stop="click"></span>
</template>

<script>
export default {
  props: ['url', 'customStyle'],
  computed: {
    cStyle() {
      return {
        ...(this.style || {}),
        backgroundImage: `url(${this.url})`
      };
    }
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="less" scoped>
.custom-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-size: 100%;
  vertical-align: bottom;
}
</style>
